var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1896_1644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 92
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1896_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.6015 18.9903V13.187C68.6015 7.0062 63.48 2 57.1569 2H20.1478C13.8246 2 8.70312 7.0062 8.70312 13.187V78.813C8.70312 84.9938 13.8246 90 20.1478 90H57.1569C63.48 90 68.6015 84.9938 68.6015 78.813V71.7512",
    stroke: "#20ACE3",
    strokeWidth: 3,
    strokeMiterlimit: 13.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3514 77.9595C39.6934 77.9595 39.1641 77.4421 39.1641 76.7988C39.1641 76.1556 39.6934 75.6382 40.3514 75.6382C41.0095 75.6382 41.5388 76.1556 41.5388 76.7988C41.5388 77.4421 41.0095 77.9595 40.3514 77.9595Z",
    fill: "#20ACE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8359 15.2563H42.4609",
    stroke: "#20ACE3",
    strokeWidth: 4,
    strokeMiterlimit: 13.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0803 34.6533L39.6385 42.4003C37.2351 44.4 37.2351 48.0358 39.6385 50.0355L49.0803 57.7825",
    stroke: "#20ACE3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6016 34.6519L81.8574 42.3989C84.2608 44.3986 84.2608 48.0343 81.8574 50.034L72.6016 57.781",
    stroke: "#20ACE3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3611 28.7926C67.5326 28.2301 67.2083 27.6391 66.6366 27.4725C66.065 27.3059 65.4625 27.6269 65.291 28.1894L54.6239 63.1659C54.4523 63.7284 54.7767 64.3195 55.3483 64.486C55.92 64.6526 56.5225 64.3317 56.694 63.7692L67.3611 28.7926Z",
    fill: "#20ACE3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.e7cf3cd065e20bf13f9d53bda60ce1d3.svg";
export { ForwardRef as ReactComponent };